require("../coord/radar/Radar");

require("../coord/radar/RadarModel");

require("./radar/RadarView");


//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts/lib/component/radar.js
// module id = 997V
// module chunks = 1